export default {
  en: "English",
  ar: "اللغة العربية",
};
